// Copyright (c) 2022 Celadon Development LLC, All rights reserved.
// Author Alexander Mikholap <alexander.miholap@celadon.ae>
import GlobalStyles from '../../../../config/styles';

const styles = () => ({
  container: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  circle: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    // Slightly deeper than the original 8px/10px so the larger amount below
    // does not look cramped inside the pill.
    padding: '8px 14px',
    borderRadius: 20,
    backgroundColor: GlobalStyles.color.COLOR_GREEN
  },
  // Explicit colour: this used to inherit a dark colour from PaperLayout, and
  // once that wrapper went it inherited white and vanished against the panel.
  descText: {
    margin: 0,
    fontSize: GlobalStyles.fonts.FONT_SIZE_SMALL,
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_REGULAR,
    color: GlobalStyles.color.COLOR_GREY,
  },
  // The figure the shop reads back to the customer, so it carries more weight
  // than the label next to it.
  priceText: {
    margin: 0,
    color: GlobalStyles.color.COLOR_PRIMARY,
    fontSize: GlobalStyles.fonts.FONT_SIZE_TITLE,
    fontFamily: GlobalStyles.fonts.FONT_ANLTP_BOLD,
  }
});

export default styles;
